@import '../../../../utils/global.module.less';
@import '../messages_shared.module.less';

.userMessage {
    background-color: #f1f7fe;
    border-radius: 20px;
    padding: 5px;
    max-width: 80%;
    margin-left: auto;
    margin-right: 16px;
    padding: 14px;
    text-align: right;
    .message_text_style();
}
